import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { supabase } from '../supabaseClient';

const BlogPostPage = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlog();
  }, [slug]);

  async function fetchBlog() {
    setLoading(true);
    const { data, error } = await supabase
      .from('blogs')
      .select('*')
      .eq('slug', slug)
      .single();

    if (error) console.error(error);
    else setBlog(data);
    setLoading(false);
  }

  if (loading) return <div style={{ padding: '10rem 0', textAlign: 'center' }}>Yükleniyor...</div>;
  if (!blog) return <div style={{ padding: '10rem 0', textAlign: 'center' }}>Yazı bulunamadı. <Link to="/blog">Geri Dön</Link></div>;

  return (
    <div className="page-wrapper">
      <Helmet>
        <title>{blog.title} | NetTest Blog</title>
        <meta name="description" content={blog.excerpt} />
        <link rel="canonical" href={`https://nettesttestere.com/blog/${blog.slug}`} />
      </Helmet>
      <div className="blog-post-header">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Anasayfa</Link>
            <span>/</span>
            <Link to="/blog">Blog</Link>
            <span>/</span>
            <span>{blog.title}</span>
          </div>
          <h1 className="post-title">{blog.title}</h1>
          <div className="post-meta">
            <span><i className="fa-solid fa-calendar"></i> {new Date(blog.published_at).toLocaleDateString('tr-TR')}</span>
            <span><i className="fa-solid fa-user"></i> {blog.author}</span>
          </div>
        </div>
      </div>

      <div className="container" style={{ paddingBottom: '5rem' }}>
        <article className="blog-post-content">
          <div 
            className="rich-content" 
            dangerouslySetInnerHTML={{ __html: (blog.content || '').replace(/\n/g, '<br />') }} 
          />
        </article>

        <div className="post-footer-cta">
          <h3>Teknik bir sorunuz mu var?</h3>
          <p>Uzman ekibimiz size en doğru testereyi seçmeniz için ücretsiz danışmanlık sağlıyor.</p>
          <a href="https://wa.me/905470013478" target="_blank" rel="noopener noreferrer" className="btn-primary">
            <i className="fa-brands fa-whatsapp"></i> Hemen WhatsApp'tan Sorun
          </a>
        </div>
      </div>
    </div>
  );
};

export default BlogPostPage;
